import React from "react"

const H1 = (
    <svg
        stroke="currentColor"
        fill="none"
        strokeWidth="2"
        viewBox="0 0 24 24"
        strokeLinecap="round"
        strokeLinejoin="round"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M12 18V6"></path>
        <path d="M17 10v3a1 1 0 0 0 1 1h3"></path>
        <path d="M21 10v8"></path>
        <path d="M4 12h8"></path>
        <path d="M4 18V6"></path>
    </svg>
)

export default H1
